import {
  getMohCodeExtendedData,
  MohClaimType,
  IMohClaimableItem,
} from '@principle-theorem/principle-core/interfaces';

export enum MohTreatmentCategory {
  StandardPackage = 'standardPackage',
  AdditionalTreatment = 'additionalTreatment',
  RequiresApproval = 'requiresApproval',
}

export interface IMohCategorisedTreatmentData {
  [MohTreatmentCategory.StandardPackage]: IMohClaimableItem[];
  [MohTreatmentCategory.AdditionalTreatment]: IMohClaimableItem[];
  [MohTreatmentCategory.RequiresApproval]: IMohClaimableItem[];
  showStandardPackage: boolean;
  showAdditionalTreatment: boolean;
  showRequiresApproval: boolean;
}

export class MohHelpers {
  static getCategorisedTreatmentData(
    items: IMohClaimableItem[],
    claimType: MohClaimType,
    isAnnualConsultation: boolean
  ): IMohCategorisedTreatmentData {
    const groups = items.reduce(
      (previous, current) => {
        const category = this.categoriseClaimableItem(
          current,
          claimType,
          isAnnualConsultation
        );
        if (category) {
          previous[category].push(current);
        }
        return previous;
      },
      {
        [MohTreatmentCategory.StandardPackage]: [] as IMohClaimableItem[],
        [MohTreatmentCategory.AdditionalTreatment]: [] as IMohClaimableItem[],
        [MohTreatmentCategory.RequiresApproval]: [] as IMohClaimableItem[],
      }
    );

    return {
      ...groups,
      showStandardPackage:
        claimType === MohClaimType.OHSA && !!groups.standardPackage.length,
      showAdditionalTreatment: !!groups.additionalTreatment.length,
      showRequiresApproval: !!groups.requiresApproval.length,
    };
  }

  static categoriseClaimableItem(
    item: IMohClaimableItem,
    claimType: MohClaimType,
    isAnnualConsultation: boolean
  ): MohTreatmentCategory | undefined {
    const extendedData = getMohCodeExtendedData(item.serviceCode.code);
    if (!extendedData?.claimTypes?.includes(claimType)) {
      return;
    }

    const isIncludedInStandardPackage =
      claimType === MohClaimType.OHSA && extendedData.inStandardPackage;
    if (isAnnualConsultation && isIncludedInStandardPackage) {
      return MohTreatmentCategory.StandardPackage;
    }

    return extendedData.preApprovalClaimTypes?.includes(claimType)
      ? MohTreatmentCategory.RequiresApproval
      : MohTreatmentCategory.AdditionalTreatment;
  }
}
